import { z } from 'zod';

// 通知の基本型
export interface Notification {
  id: number;
  user_id: number;
  message: string;
  reference_type: 'video' | 'comment' | 'system' | string;
  reference_id: number | null;
  video_id: number | null;
  is_read: boolean;
  isRead?: boolean; // 互換性のために残す
  created_at: string;
  updated_at: string;
  video?: {
    id: number;
    [key: string]: unknown;
  };
}

// ローカルストレージ用のキー
export const NOTIFICATIONS_STORAGE_KEY = 'medtube_notifications';
export const LOCALLY_UNREAD_KEY = 'medtube_locally_unread_notifications';

// 通知一覧のレスポンス型
export const NotificationsResponseSchema = z.object({
  success: z.boolean(),
  data: z.object({
    notifications: z.array(z.object({
      id: z.number(),
      user_id: z.number(),
      message: z.string(),
      reference_type: z.string(),
      reference_id: z.number().nullable(),
      video_id: z.number().nullable(),
      is_read: z.boolean().optional(),
      isRead: z.boolean().optional(),
      created_at: z.string(),
      updated_at: z.string(),
      video: z.object({
        id: z.number()
      }).optional()
    })),
    totalCount: z.number().optional(),
    unreadCount: z.number().optional(),
    currentPage: z.number().optional(),
    totalPages: z.number().optional(),
    total: z.number().optional(),
    page: z.number().optional(),
    limit: z.number().optional()
  })
});

export type NotificationsResponse = z.infer<typeof NotificationsResponseSchema>;

// 未読カウントのレスポンス型
export const UnreadCountResponseSchema = z.object({
  data: z.object({
    count: z.number()
  })
});

export type UnreadCountResponse = z.infer<typeof UnreadCountResponseSchema>;

// 既読/未読更新のレスポンス型
export const ReadStatusResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  data: z.any().optional()
});

export type ReadStatusResponse = z.infer<typeof ReadStatusResponseSchema>;

// 管理者通知送信のリクエスト型
export interface AdminNotificationRequest {
  message: string;
}

// 管理者通知送信のレスポンス型
export const AdminNotificationResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  data: z.any().optional()
});

export type AdminNotificationResponse = z.infer<typeof AdminNotificationResponseSchema>;

// モック通知データ型
export interface MockNotificationData {
  notifications: Notification[];
  unreadCount: number;
}

// ローカルの通知状態管理の設定
export interface NotificationServiceConfig {
  useMockOnError: boolean;
} 